import { ProductVariant } from '../models';

export const isVariantAvailable = (availableSizes: string[]) => (
  variant: ProductVariant,
) =>
  variant.children?.some((size) => availableSizes.indexOf(size.productId) >= 0);
